import { Card, CardSize } from "../GameTypes/game.type";

const runAnimation = (
  isPlayer: boolean,
  dealerCardCount: number, 
  handIndex: number,
  playerCards: Card[][],
  dealingIndex: number,
  cardSize: CardSize,
  DeckCardRef: React.MutableRefObject<HTMLDivElement | null>,
  dealerHandRef: React.MutableRefObject<HTMLDivElement | null>,
  playerHandRef: React.MutableRefObject<HTMLDivElement | null>,
  playerSplitHandRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  if (
    !DeckCardRef.current ||
    (!isPlayer && !dealerHandRef.current) ||
    (isPlayer &&
      !(handIndex === 0 ? playerHandRef.current : playerSplitHandRef.current))
  )
    return;

  let translateX: number | undefined, translateY: number | undefined;
  const deckCard = DeckCardRef.current.getBoundingClientRect();
  const targetHand = (
    isPlayer
      ? handIndex === 0
        ? playerHandRef
        : playerSplitHandRef
      : dealerHandRef
  ).current!.getBoundingClientRect();

  const cardCount = isPlayer ? playerCards[handIndex].length : dealerCardCount;
  const offsetX = cardCount * (cardSize.width + cardSize.gap);

  if (dealingIndex === 0) {
    const firstCard = playerHandRef
      .current!.querySelector("#empty2")
      ?.getBoundingClientRect();
    if (firstCard) {
      translateX = firstCard.x - cardSize.gap - deckCard.x;
      translateY = firstCard.y - deckCard.y;
    }
  } else if (dealingIndex === 1) {
    const firstCard = dealerHandRef
      .current!.querySelector("#empty1")
      ?.getBoundingClientRect();
    if (firstCard) {
      translateX = firstCard.x - cardSize.gap - deckCard.x;
      translateY = firstCard.y - deckCard.y;
    }
  } else {
    translateX = targetHand.x + offsetX - deckCard.x;
    translateY = targetHand.y - deckCard.y;
  }

  if (translateX !== undefined && translateY !== undefined) {
    DeckCardRef.current.style.width = `${cardSize.width}px`;
    DeckCardRef.current.style.height = `${cardSize.height}px`;
    DeckCardRef.current.style.transition = `transform 0.2s ease-out, opacity 0.05s cubic-bezier(0.4, 0, 0.2, 1)`;
    DeckCardRef.current.style.transform = `translate(${translateX}px, ${translateY}px) scale(0.7)`;
    DeckCardRef.current.style.opacity = "1";

    setTimeout(() => {
      DeckCardRef.current!.style.transition = "none";
      DeckCardRef.current!.style.transform = "translate(0rem, 0rem) scale(0.7)";
      DeckCardRef.current!.style.opacity = "1";
    }, 150);
  }
};

const setRef = (
  deckCard: HTMLDivElement | null,
  DeckCardRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  DeckCardRef.current = deckCard;
};

const setDealerHandRef = (
  targetLocation: HTMLDivElement | null,
  dealerHandRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  dealerHandRef.current = targetLocation;
};

const setPlayerHandRef = (
  targetLocation: HTMLDivElement | null,
  playerHandRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  playerHandRef.current = targetLocation;
};

const setPlayerSplitHandRef = (
  targetLocation: HTMLDivElement | null,
  playerSplitHandRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  playerSplitHandRef.current = targetLocation;
};

const setCardDimensions = (
  size: CardSize,
  setCardSize: React.Dispatch<React.SetStateAction<CardSize>>
) => {
  setCardSize(size);
};

export {
  runAnimation,
  setRef,
  setDealerHandRef,
  setPlayerHandRef,
  setPlayerSplitHandRef,
  setCardDimensions,
};
